/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_SavedInputs */

const en_profile_saved = /** @type {(inputs: Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile saved`)
};

const es_profile_saved = /** @type {(inputs: Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil guardado`)
};

/**
* | output |
* | --- |
* | "Profile saved" |
*
* @param {Profile_SavedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_saved = /** @type {((inputs?: Profile_SavedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_SavedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_saved(inputs)
	return en_profile_saved(inputs)
});